export function makeid(length: number) {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export enum BackButtonAction {
  GO_BACK,
  TO_HOME,
  POP_OUT,
  TO_BARCODE_PAGE,
  TO_MISSING_SIZE,
  BLOCK_NAVIGATION,
  TO_CHECKOUT_HOME,
  TO_RESETMISSING_SIZE,
}
